module.exports = __webpack_public_path__ + "img/carpets-sprite-2x.bc05ba6e.png";